/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 16,
    height: 16,
    viewBox: '0 0 54 54',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M41.53 33.61V20.47a4.67 4.67 0 0 0-4.66-4.66H17.13a4.66 4.66 0 0 0-4.66 4.66v13.14a4.66 4.66 0 0 0 4.66 4.66h19.74a4.65 4.65 0 0 0 3.3-1.37 7.35 7.35 0 0 0 5.32 2.28 7.1 7.1 0 0 0 4.8-1.85 8.54 8.54 0 0 0 2.55-4.45 26.49 26.49 0 1 0-13.47 17.56M39.78 20l-11.13 7.5a2.79 2.79 0 0 1-3.26 0L14.22 20" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/mail.js